/**
 * List Item component
 * @author Liwei Yeh <liwei.yeh@adasasistemas.com>
 */

import { BeatLoader } from 'react-spinners';

import styles from './loader.module.scss';

/**
 * Display loader when data is loading
 * @param {LoaderProps} Prop
 * @returns  a styled list item
 */
interface LoaderProps {
	size?: 'small' | 'medium' | 'large' | number;
}

export const Loader = ({ size = 'large' }: LoaderProps) => {
	const numericSize =
		typeof size === 'number' ? size : size === 'small' ? 8 : size === 'large' ? 30 : 15;

	return (
		<div className={styles['loader-container']}>
			<BeatLoader className={styles['loader-spinner']} size={numericSize} />
		</div>
	);
};
